import axios from "axios";

// Constants
import constants from "@/constants";
import { handleCommonRequest, handleCommonResponse } from "./common-response";

let cmsInstance = axios.create({
    baseURL: constants.cmsApi,
    headers: {},
});

handleCommonRequest(cmsInstance, false);
handleCommonResponse(cmsInstance);

export default cmsInstance;
